import simpleBannerList from './SimpleBannerList';

export default simpleBannerList;
